<template>
  <div>
    <div class="bg customer-login">
      <div class="login">
        <div class="form">
          <div class="form-logo">
            <div>
              <img src="../assets/img/leemma_logo_blue.png" alt="">
            </div>
            <span>利马砖瓦焙烧监控系统</span>
          </div>
          <form>
            <div class="form-group">
              <input v-model="userName" type="text" class="form-control" placeholder="用户名">
            </div>
            <div class="form-group">
              <input v-model="password" type="password" class="form-control" placeholder="密码">
            </div>
            <a href="#">忘记密码？</a>

          </form>
          <button @click="login" class="btn btn-primary button">登录系统</button>
          <div class="split-line"></div>
          <a :href="wxurl" class="btn btn-primary wx-button button"><i class="iconfont icon-wx "
                                                                       style="    margin: 0 8px;"></i>微信登陆</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'leemmaCustomer',
    data() {
      return {
        wxUrl: '',
        userName: '',
        password: '',
        state: this.$route.query.type
      }
    },
    created() {
      this.makeUrl();
      this.checkWxBrowser()
    },
    methods: {
      makeUrl() {
        let appid = 'wx64554769b588ff68',
          redirect_url = location.href;
        this.wxurl = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
      },
      checkWxBrowser() {
        let ua = window.navigator.userAgent.toLowerCase(),
          urlParams = this.$route.query,
          appid = 'wx64e8514ac107ac11',
          url = location.href;
        //判断微信浏览器
        debugger
        if (ua.match('micromessenger')) {
          console.log('wx');
          let state = urlParams.state;
          let params = {
            code: this.$route.query.code, type: 'customer'
          };
          if (urlParams.code) {
            this.$http.get('wechat_authorize/userinfo', {params}).then(data => {
              if (data.status_code === 'SUCCEEDED') {
                location.href = 'https://customers.leemma.com?customer_token=' + data.payload.auth_token
              }
            })
          } else {
            location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=snsapi_userinfo&state=' + state + '#wechat_redirect'
          }
        } else {
          if (urlParams.code) {
            this.wxLogin()
          }
        }
      },
      wxLogin() {
        let params = {
          code: this.$route.query.code, type: 'customer'
        };
        this.$http.get('wechat_login/userinfo', {params}).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            location.href = `https://customers.leemma.com?customer_token=${data.payload.auth_token}&type=${this.state?this.state:""}`;
          }
        })

      },
      login() {
        let url = 'customer_sessions/create',
          params = {
            name: this.userName,
            password: this.password,
          };
        this.$http.post(url, params).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.$message.success("登陆成功");
            location.href = `https://customers.leemma.com/login?customer_token=${data.payload.customer_token}&type=${this.state?this.state:""}`
          }else{
            this.$message.error(data.msg);
          }
        })
      }
    }

  }
</script>

<style type="scss" scoped>
  .color-blue {
    color: #057EFB
  }

  .customer-login {
    background: url('../assets/img/customer-login-bg.png');
    background-size: cover;
    color: #000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    min-width: 1000px;
    z-index: -10;
    zoom: 1;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;

  }

  .login {
    position: absolute;
    right: 50%;
    margin-right: -250px;
    top: 50%;
    margin-top: -250px;
    width: 500px;
    background: #fff;
    box-shadow: 0px 10px 20px 5px rgba(0, 0, 0, .3)

  }

  .form {
    width: 75%;
    text-align: center;
    margin: auto;
    padding-bottom: 30px;

  }

  input {
    height: 42px
  }

  .form-logo {
    width: 100%;
    margin: 40px auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    color: #057EFB;

  }

  .form-logo > span {
    font-size: 16px;
  }

  .form-logo img {
    width: 180px;
  }

  div.session_email, div.session_name, div.session_password {
    width: 100%;
    margin-bottom: 30px;
    border-radius: 5px;
    height: 42px;
  }

  div.session_email input, div.session_name input, div.session_password input {
    height: 42px;
    border-width: 1px;
    border-color: #057EFB
  }

  .customer-login .button {
    font-size: 16px;
    color: #fff;
    width: 100%;
    height: 42px;
    margin: 15px 0;
    background: #057EFB;
    border-radius: 5px;
  }

  .customer-login .wx-button {
    background: #62B900;
    text-indent: -33px;
  }

  .split-line {
    border-top: 1px solid #dddddd;
  }

  @media (max-width: 800px) {
    body {

    }
    .customer-login {
      padding-top: 30%;
      min-width: auto;
    }
    .login {
      max-width: 417px;
      width: 95%;
      left: 0;
      top: 0;
      position: relative;
      margin: 0 auto;
      margin-top: 0px;

    }
    .form {
      padding-bottom: 10px;
      width: 80%;
      margin: auto;
      padding: 1px 0;
    }
    .form-logo {
      margin: 20px 0;
    }
    .form-logo > span {
      font-size: 12px;
    }
    .form-logo img {
      width: 150px;
    }
    div.session_name {
      margin-bottom: 20px;
    }
    .alert-danger {
      z-index: 2;
      width: 100%;
      position: fixed;
      left: 0;
      top: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/leemmaCustomer.vue